<template>
  <div>
    <div class="stoplist-navbar">
      <div class="navbar-titles" v-if="!is_searching">
        <div class="qrw-container-title-xs page-title">
          {{ $t('navbar.stoplist') }}
        </div>
        <div class="qrw-container-title-sm menu-title"  @click="is_menu_list_open = !is_menu_list_open">
          {{ menuTitle }}
          <BaseIcon :icon="is_menu_list_open ? 'arrow-up' :  'arrow-down'" />
        </div>
      </div>
      <div class="navbar-titles w-100" v-else>
        <BaseInput 
          size="lg" 
          leftIcon="search"
          icon="search"
          rightIcon="cross"
          iconPosition="both"
          @iconClicked="onSearchInputIconClicked"
          class="search-input w-100"
          v-model="search" :placeholder="$t('stoplist.search_ph')" />
      </div>
      <div class="navbar-actions ml-16">
        <BaseIcon
          icon="search"
          v-if="!is_searching"
          @click="is_searching = true"
          class="search-icon"
          size="sm2"
        />
        <div class="action-divider ml-16" v-if="!is_searching"></div>
        <BaseIcon
          icon="cross"
          size="sm2"
          :class="is_searching ? '' : 'ml-16'"
          @click="onCloseClicked"
        />
      </div>
    </div>

    <BurgerMenu
      :value="menu._id"
      @input="id => {$emit('selectMenu', id); is_menu_list_open = false}" 
      @close="is_menu_list_open = false"
      :items="burgerMenuItems"
      v-if="is_menu_list_open"/>
  </div>
</template>

<script>
import BurgerMenu from "@/components/common/BurgerMenu.vue";

export default {
  data() {
    return {
      is_searching: false,
      search: null,
      is_menu_list_open: false
    };
  },
  props: {
    menus: Array,
    menu: Object
  },
  components: {
    BurgerMenu,
  },
  watch: {
    search() {
      this.$emit('search', this.search);
    }
  },
  computed: {
    burgerMenuItems() {
      return this.menus.map(m => {
        return {
          value: m._id,
          text_left: m.title,
          text_right: `${m.categories.length} | ${m.products.length}`
        }
      });
    },
    menuTitle() {
      if (!this.menu) return 'Menu';

      const title = this.menu.title;

      if (title.length > 23) {
        return title.substring(0,23) + '..';
      } else {
        return title;
      }
    }
  },
  methods: {
    onCloseClicked() {
      if (this.is_searching) {
        this.is_searching = false;
        this.search = null;
      } else {
        this.$router.push("/orders");
      }
    },
    onSearchInputIconClicked(pos) {
      if (pos == 'right') {
        this.search = null;
        this.is_searching = false;
      }
    } 
  },
};
</script>

<style scoped>
.stoplist-navbar {
  width: 100%;
  background: var(--black-4-color);
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  padding: 8px 16px;
  color: var(--white-10-color);
}

.search-icon {
  color: var(--grey-7-color);
}

.navbar-actions {
  display: flex;
  align-content: center;
  align-items: center;
  align-self: center;
}

.search-input {
  color: var(--grey-2-color);
}

.action-divider {
  height: 40px;
  width: 1px;
  background: var(--white-10-color);
  opacity: 0.16;
}

.page-title {
  opacity: 0.8;
}
</style>